<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "UpdateActionForm",
  data() {
    return {
      id: null,
      selectedParent: null,
      entity_id: null,
      parent_id: null,
      selecedIds: null,
      parentName: null,
    };
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo", "getModalState"]),
    ...mapGetters("userType", [
      "getParentsList",
      "getModalState",
      "getLoading",
    ]),
  },
  watch:{
    getModalState(state) {
      state && this.$bvModal.hide("moveUserTypes");
    },
  },
  methods: {
    ...mapActions("userType", ["moveUserType", "fetchParentsList"]),
    onSubmit() {
      this.moveUserType({
        parentId: this.selectedParent.id,
        userTypeId: this.getModalInfo.length > 1 ?  [...new Set(this.selecedIds)]  : this.id,
      }).then(()=>{
        this.$emit('updateUserTypeOrDeleted');
        this.getModalState && this.$bvModal.hide("moveUserTypes");
      });
    },

  },
  beforeMount() {
    if (Array.isArray(this.getModalInfo)) {
      this.parent_id = this.getModalInfo[0].parent_id;
      this.entity_id = this.getModalInfo[0].entity_id;
      this.selecedIds = this.getModalInfo.map((row) => row.id);
    } else {
    const { id, entity_id, parent_name , parentId } = this.getModalInfo;
    this.id = id;
    this.entity_id = entity_id;
    this.parent_id = parentId;
    this.parentName = parent_name;
    }
    this.fetchParentsList(this.getModalInfo);
  },
};
</script>

<template>
  <div class="update-user-type-wrapper">

    <div class="modal-main-header">
      <div>
        <h3 class="modal-header-changeType">{{ $t("userTypes.form.moveUserType") }}</h3>
      </div>
        <svg
        class="header-close"
        @click="$bvModal.hide('moveUserTypes')"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
          fill="#F46A6A"
        />
      </svg>
    </div>
    <div class="form-groups">
      <p class="font-weight-normal" v-if="!Array.isArray(this.getModalInfo)">
        {{ $t("userTypes.form.currnetParentIs") }}
        <span class="text-primary ml-4">{{ parentName&&parentName }}</span>
      </p>
      <!-- name   -->
      <div class="input-box mb-3 d-flex align-items-center pb-5 mb-5">

        <VpMultiselect class="top-15" zIndex="10" :showPlaceholderIcon="true" width="416" :isLoading="false" :showOptionsBorder="true" 
        :showNoResults="true"  v-model="selectedParent" label="name" :options="getParentsList" :allowEmpty="true" :show-labels="false"
        :title="$t('common.notes.selectParentYouWantToMove')"  :noResultMessage="$t('common.notes.noElementsFound')" 
        />
      </div>
    </div>




    <div class="line-divider"></div>
    <div class="d-flex justify-content-center">
      <button
    :disabled="!selectedParent || getLoading"
    class="change-type"
    size="md"
    @click="onSubmit"
      >
      {{ $t("common.confirm") }}
        <i
          v-if="getLoading"
          class="bx bx-loader bx-spin font-size-16 align-middle rounded"
        ></i>
      </button>
      <button
        :disabled="getLoading"
        @click="$bvModal.hide('moveUserTypes')"
        class="cancel-type"
      >
        {{ $t('common.cancel') }}
      </button>
    </div>



  </div>
</template>
<style lang="scss" scoped>
.update-user-type-wrapper {
  .header {
    background-color: #f8f8fb;
    padding: 1.5% 0px;
    margin-bottom: 1%;
  }
  .modal-title {
    text-align: center;
    font-size: 16px;
  }
  .input-label {
    width: 130px;
  }
}
</style>

<style lang="scss">
div#moveUserTypes___BV_modal_content_ {
  width: 500px !important;
  border-radius: 26px !important;
  margin-top: 120px;
  .modal-main-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 40px;
    .modal-header-changeType {
      color: #000;
      font-size: 17px;
      font-weight: 700;
      line-height: normal;
      line-height: 100%;
      text-align: center;
    }

    .header-close{
      margin: -8px -10px; 
    }
  }

  .modal-main-header:lang(ar) {
    margin-right: 137px;
  }

  .modal-main-header:not(:lang(ar)){
    margin-left: 147px;
  }

  .modal-main-content {
    width: 416px;
    margin: auto;
    .modal-msg {
      margin-bottom: 32px;
      color: #787878;

      font-size: 16px;

      font-weight: 400;
      width: 414px;

    line-height: 24px;
    letter-spacing: 0%;

    }
  }

  .line-divider {
    height: 1px;
    background-color: #707070;
    opacity: 0.15;
    margin-top: 40px;
    margin-bottom: 24px;
  }

  button.cancel-type {
    width: 112px;
    height: 32px;
    color: #f46a6a;
    margin-inline-start: 16px;
    background-color: transparent;
    border-radius: 26px;
    border: solid 1px #f46a6a;
    text-align: center;

    font-size: 16px;

    font-weight: 400;
    line-height: normal;
  }

  button.change-type {
    width: 112px;
    height: 32px;
    color: #ffffff;
    margin-inline-end: 16px;
    background-color: #103f5e;
    border-radius: 26px;
    border: solid 1px #103f5e;
    text-align: center;

    font-size: 16px;

    font-weight: 400;
    line-height: normal;
    &:disabled {
      opacity: 0.4;
    }
  }
}
</style>
